export default __webpack_public_path__ + "static/media/Tasset of the Valiant.30df2eaa.jpg";